import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchProcessStepCatalog } from "#modules/quoteRequestLines/infra/fetchProcessStepCatalog.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";
import { MaterialGradeSchema, MaterialGradeType } from "shared";

export const processStepCatalogQuery = (
  materialGrade: MaterialGradeType = MaterialGradeSchema.enum.STEEL,
) => ({
  queryKey: queryKeys.processStepCatalog.all,
  queryFn: () => fetchProcessStepCatalog({ materialGrade }),
  staleTime: STALE_TIME,
});
